"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchAnnouncementsData = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _AnnouncementFetcher = require("./AnnouncementFetcher");

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * This function handles the case where token got invalidated
 * and pulse is not aware of it. So we need to stop the polling for that case.
 *
 * @param status
 * @param announcementPollingIntervalId
 */
var checkAndStopPolling = function checkAndStopPolling(status, announcementPollingIntervalId) {
  var announcementStatus = status.announcements;
  var localizationStatus = status.localization;
  if (announcementStatus && announcementStatus >= 400 && announcementStatus <= 404 || localizationStatus && localizationStatus >= 400 && localizationStatus <= 404) clearInterval(announcementPollingIntervalId);
};
/**
 * Poll for announcements from status.adobe.com.
 */


var fetchAnnouncementsData =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(store) {
    var res, announcementPollingIntervalId, fetchData, _fetchData;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _fetchData = function _ref3() {
              _fetchData = (0, _asyncToGenerator2.default)(
              /*#__PURE__*/
              _regenerator.default.mark(function _callee() {
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return (0, _AnnouncementFetcher.fetchAnnouncements)(store);

                      case 2:
                        res = _context.sent;
                        checkAndStopPolling(res, announcementPollingIntervalId);

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
              return _fetchData.apply(this, arguments);
            };

            fetchData = function _ref2() {
              return _fetchData.apply(this, arguments);
            };

            _context2.next = 4;
            return (0, _AnnouncementFetcher.fetchAnnouncements)(store);

          case 4:
            res = _context2.sent;
            checkAndStopPolling(res, announcementPollingIntervalId);
            return _context2.abrupt("return", {
              start: function start() {
                announcementPollingIntervalId = window.setInterval(fetchData, 180000);
              },
              stop: function stop() {
                clearInterval(announcementPollingIntervalId);
              }
            });

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAnnouncementsData(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchAnnouncementsData = fetchAnnouncementsData;
var _default = {
  fetchAnnouncementsData: fetchAnnouncementsData
};
exports.default = _default;